export const eventStatuses = [
  'planned',
  'locked',
  'cancelled',
  'deleted',
] as const

type EventStatus = typeof eventStatuses[number]
export default EventStatus
